import { useContext, useEffect } from "react";
import { PageContext } from "./PageContext";
export const usePageContext = () => useContext(PageContext);
export const usePageBackgroundImage = imageName => {
  const {
    setBackgroundImage
  } = usePageContext();
  useEffect(() => {
    setBackgroundImage(imageName);
  }, [imageName, setBackgroundImage]);
};
export const usePageSpeedDealActions = actions => {
  const {
    setSpeedDialActions
  } = usePageContext();
  useEffect(() => {
    setSpeedDialActions(actions);
  }, [actions, setSpeedDialActions]);
};
export const usePageSpeedIconWithAction = iconWithAction => {
  const {
    setSpeedDialIconWithAction
  } = usePageContext();
  useEffect(() => {
    setSpeedDialIconWithAction(iconWithAction);
  }, [iconWithAction, setSpeedDialIconWithAction]);
};
export const useSpeedDealMenuOpened = value => {
  const {
    setSpeedDealMenuOpened
  } = usePageContext();
  useEffect(() => {
    setSpeedDealMenuOpened(value);
  }, [value, setSpeedDealMenuOpened]);
};
export const useBackgroundOpacity = backgroundOpacity => {
  const {
    setBackgroundOpacity
  } = usePageContext();
  useEffect(() => {
    setBackgroundOpacity(backgroundOpacity);
  }, [backgroundOpacity, setBackgroundOpacity]);
};
export const usePageHeaderMenuActions = actions => {
  const {
    setHeaderMenuActions
  } = usePageContext();
  useEffect(() => {
    setHeaderMenuActions(actions);
  }, [actions, setHeaderMenuActions]);
};
export const useTitle = title => {
  const {
    setTitle
  } = usePageContext();
  useEffect(() => {
    setTitle(title);
  }, [title, setTitle]);
};